module.exports = __webpack_public_path__ + "static/media/greenhouse2Step11-2.d103ee46.png";